var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsersRoles = function SvgUsersRoles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#users-roles_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67,
    d: "M14.167 17.5v-1.667a3.333 3.333 0 0 0-3.333-3.333H4.167a3.333 3.333 0 0 0-3.334 3.333V17.5m18.334 0v-1.667a3.33 3.33 0 0 0-2.5-3.225m-3.334-10a3.334 3.334 0 0 1 0 6.459m-2.5-3.234a3.333 3.333 0 1 1-6.666 0 3.333 3.333 0 0 1 6.667 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "users-roles_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgUsersRoles;